import { render, staticRenderFns } from "./AdvantInfo.vue?vue&type=template&id=0640e38c&scoped=true&"
import script from "./AdvantInfo.vue?vue&type=script&lang=ts&"
export * from "./AdvantInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AdvantInfo.vue?vue&type=style&index=0&id=0640e38c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640e38c",
  null
  
)

export default component.exports